import { loadData } from "./dataLoader";

let saviors;

loadData("saviors.json").then((data) => (saviors = data));

let ranks = null;

const STAT_TYPE = {
    NST_ATK: "atk",
    NST_HP: "hp",
    NST_DEF: "def",
    NST_TURN_SPEED: "spd",
    NST_NV_RATE_ATK: "atk_rate",
    NST_NV_RATE_HP: "hp_rate",
    NST_NV_RATE_DEF: "def_rate",
    NST_RATE_CRITICAL: "crit_rate",
    NST_RATE_CRITICAL_DAMAGE: "crit_dmg",
    NST_RATE_EFFECT_HIT: "eff_rate",
    NST_RATE_EFFECT_EVADE: "eff_resist",
};

const RANK_KEYS = ["atk", "hp", "def", "spd", "crit_rate", "crit_dmg"];

const addTotalResonance = (leveledStats, resonances) => {
    const obj = {};

    for (const resonance of resonances) {
        const stats = resonance.stats;

        if (stats) {
            for (const stat of stats) {
                if (obj[stat.type]) obj[stat.type] += stat.value;
                else obj[stat.type] = stat.value;
            }
        }
    }

    leveledStats[STAT_TYPE.NST_ATK] += obj[STAT_TYPE.NST_ATK] || 0;
    leveledStats[STAT_TYPE.NST_HP] += obj[STAT_TYPE.NST_HP] || 0;
    leveledStats[STAT_TYPE.NST_DEF] += obj[STAT_TYPE.NST_DEF] || 0;
    leveledStats[STAT_TYPE.NST_TURN_SPEED] += obj[STAT_TYPE.NST_TURN_SPEED] || 0;
    leveledStats[STAT_TYPE.NST_RATE_CRITICAL] =
        (leveledStats[STAT_TYPE.NST_RATE_CRITICAL] * 10_000 + (obj[STAT_TYPE.NST_RATE_CRITICAL] || 0) * 10_000) / 10_000;
    leveledStats[STAT_TYPE.NST_RATE_CRITICAL_DAMAGE] =
        (leveledStats[STAT_TYPE.NST_RATE_CRITICAL_DAMAGE] * 10_000 + (obj[STAT_TYPE.NST_RATE_CRITICAL_DAMAGE] || 0) * 10_000) / 10_000;
    leveledStats[STAT_TYPE.NST_RATE_EFFECT_HIT] += obj[STAT_TYPE.NST_RATE_EFFECT_HIT] || 0;
    leveledStats[STAT_TYPE.NST_RATE_EFFECT_EVADE] += obj[STAT_TYPE.NST_RATE_EFFECT_EVADE] || 0;

    leveledStats[STAT_TYPE.NST_ATK] = Math.floor(leveledStats[STAT_TYPE.NST_ATK] * (1 + (obj[STAT_TYPE.NST_NV_RATE_ATK] || 0)));
    leveledStats[STAT_TYPE.NST_HP] = Math.floor(leveledStats[STAT_TYPE.NST_HP] * (1 + (obj[STAT_TYPE.NST_NV_RATE_HP] || 0)));
    leveledStats[STAT_TYPE.NST_DEF] = Math.floor(leveledStats[STAT_TYPE.NST_DEF] * (1 + (obj[STAT_TYPE.NST_NV_RATE_DEF] || 0)));
};

const addTotalFavorStats = (totalStats, faverLevelInfos) => {
    for (const favorLevelInfo of faverLevelInfos) {
        if (favorLevelInfo.stats.length > 0) {
            totalStats.atk += favorLevelInfo.stats.find((e) => e.type === STAT_TYPE.NST_ATK).value;
            totalStats.hp += favorLevelInfo.stats.find((e) => e.type === STAT_TYPE.NST_HP).value;
            totalStats.def += favorLevelInfo.stats.find((e) => e.type === STAT_TYPE.NST_DEF).value;
        }
    }
};

// base_stat/stat_per_level을 레벨 200까지 성장시키고 공명/호감도 보너스를 합산한 최종 스탯을 구한다.
// (구원자 상세 페이지의 "개화" 토글처럼 base_stat/stat_per_level만 다른 값으로 바꿔치기해도
//  그대로 재사용할 수 있도록 savior 객체를 받아 그때그때 계산한다.)
const computeLeveledStatus = (savior) => {
    const status = structuredClone(savior.base_stat);

    for (let i = 1; i < 200; i++) {
        status.atk += savior.stat_per_level.atk;
        status.hp += savior.stat_per_level.hp;
        status.def += savior.stat_per_level.def;
    }

    addTotalResonance(status, savior.resonances);
    addTotalFavorStats(status, savior.favor_per_level);

    return status;
};

const getRankPosition = (key, value) => {
    let position = 1;

    for (const entry of ranks) {
        if ((entry.status[key] || 0) > (value || 0)) position++;
    }

    return position;
};

const construct = () => {
    if (!ranks) {
        ranks = saviors.map((e) => ({
            id: e.id,
            name: e.name,
            title: e.title,
            status: computeLeveledStatus(e),
        }));

        RANK_KEYS.forEach((key) => {
            const sorted = [...ranks].sort((a, b) => (b.status[key] || 0) - (a.status[key] || 0));

            for (let i = 0; i < sorted.length; i++) {
                const s = sorted[i];
                s.ranks = s.ranks || {};

                if (i > 0 && (sorted[i].status[key] || 0) === (sorted[i - 1].status[key] || 0)) {
                    s.ranks[key] = sorted[i - 1].ranks[key];
                } else {
                    s.ranks[key] = i + 1;
                }
            }
        });
    }

    return ranks;
};

const getSaviorStatRanks = () => {
    if (!ranks) construct();

    return ranks;
};

// savior 객체를 그대로 받아 그 값(예: 개화 상태의 base_stat/stat_per_level) 기준으로 최종 스탯과
// 전체 구원자 대비 순위를 계산한다. 원본 구원자를 넘기면 캐시된 결과와 동일한 값이 나온다.
const getSaviorStatRank = (savior) => {
    if (!ranks) construct();
    if (!savior) return null;

    const status = computeLeveledStatus(savior);
    const entry = { id: savior.id, name: savior.name, title: savior.title, status, ranks: {} };

    RANK_KEYS.forEach((key) => {
        entry.ranks[key] = getRankPosition(key, status[key]);
    });

    return entry;
};

export { getSaviorStatRanks, getSaviorStatRank };
